module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-container"
  }, _vm._l((_vm.beatsArray), function(elem, index) {
    return _c('div', {
      staticClass: "box",
      class: {
        active: elem, played: index == _vm.currentNote
      },
      on: {
        "click": function($event) {
          _vm.handleClick(index)
        }
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06b3cf5e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Line.vue
// module id = 18
// module chunks = 1